import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const toggleTeachLiveTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "toggleItemTeachLive",
    onDone: {
      target: "idle",
      actions: assign({
        studyPlan: (_ctx, evt) => evt.data.plan,
        lessonDetails: (ctx, evt) => {
          const section = evt.data?.plan?.sections?.find(
            section => section.id === ctx.selectedSectionId
          )
          const changedLesson = section?.items?.find(
            lesson => lesson.contentId === ctx.selectedLessonId
          )

          const newLessonDetails = {
            ...ctx.lessonDetails,
            isTeachLive: changedLesson.teachLive
          }
          return !!changedLesson ? newLessonDetails : ctx.lessonDetails
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleItemTeachLive", {
            messageData: ["toggle teach live"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
